import { AccountDto } from '@api/core';
import { isDefined } from '@stillmandigital/common';

export function getAccountIdFromUrl(url: string): number | undefined {
  const accountId = url.startsWith('/accounts/details') ? url.split('/')[3] : undefined;

  return isDefined(accountId) ? Number(accountId) : undefined;
}

export const DEFAULT_VISIBLE_ACCOUNT_TYPES: AccountDto.AccountTypeEnum[] = [
  AccountDto.AccountTypeEnum.Company,
  AccountDto.AccountTypeEnum.Individual,
  AccountDto.AccountTypeEnum.LiquidityReceiver,
];
